import { Tab } from '../const';

/**
 * @function reorderTabs
 * @param { array } arr
 * @param { object } result
 * @returns { array }
 */
function reorderTabs(arr, result) {
	const tabs = Array.from(arr);

	const startIndex = result.source.index;

	const endIndex = result.destination.index;

	const [removed] = tabs.splice(startIndex, 1);

	tabs.splice(endIndex, 0, removed);

	for (let i = 0; i < tabs.length; i++) {
		tabs[i][Tab.Order] = String(i + 1);
	}

	return tabs;
}

export default reorderTabs;
